import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMenuFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 12.38c0-.691.56-1.25 1.25-1.25h15.5a1.25 1.25 0 0 1 0 2.5H4.25c-.69 0-1.25-.56-1.25-1.25M3 7.393c0-.69.56-1.25 1.25-1.25h15.5a1.25 1.25 0 0 1 0 2.5H4.25c-.69 0-1.25-.56-1.25-1.25M3 17.366c0-.69.56-1.25 1.25-1.25h15.5a1.25 1.25 0 0 1 0 2.5H4.25c-.69 0-1.25-.56-1.25-1.25"
  }));
}
var IcMenuFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMenuFill));

export { IcMenuFill as I };
